<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import { useTriviaStore } from '@/stores/trivia.js';
import { useRouter } from 'vue-router'; // Import useRouter
const store = useTriviaStore();

import { Authenticator } from "@aws-amplify/ui-vue";
import "@aws-amplify/ui-vue/styles.css";

import { Amplify, Auth } from 'aws-amplify';
import awsconfig from './aws-exports';

// Initialize Amplify
Amplify.configure(awsconfig);

// Initialize router
const router = useRouter(); 

function getStorage(key, item) {
  if( localStorage.getItem(key) && item) {
      const data = JSON.parse(localStorage.getItem(key))
      return data[item]
  }
  else if(localStorage.getItem(key)) {
    return localStorage.getItem(key)
  }
};


onMounted(() => {
if (getStorage('CurrentGame')) {
  store.CurrentGame = JSON.parse(getStorage('CurrentGame'));
}
});


// Handle user login on mount
onMounted(async () => {
  try {
    const currentUser = await Auth.currentAuthenticatedUser();
    store.user = currentUser;
    store.loggedIn = true;
    if (currentUser) {
      console.log("User authenticated, redirecting...");
      fetchData();
    }
  } catch (error) {
    store.systemErrorText = error.message;
    console.error('Authentication error:', error);
  }
});

// Log out user
const logout = async () => {
  try {
    await Amplify.Auth.signOut();
    store.loggedIn = false;
    store.user = null;
    console.log('User signed out successfully.');
  } catch (error) {
    console.error('Error during logout:', error);
  }
};


async function fetchData() {
  console.log('Fetching user data...');
  await store.initialLoad();
}

</script>

<template>
  <div>
    <div
        id="errorText"
        v-if="store.systemErrorText"
        style="position: relative; padding-left: 60px;">
      {{store.systemErrorText}}
      <button class="closeErrorTextButton" @click="store.systemErrorText = null">×</button>
    </div>

    <div v-else-if="store.loading" class="loadingNotification">Loading...</div>

    <div v-else-if="!store.loggedIn">
      <Authenticator>
        <template v-slot="{ user }">
          <h1>Logged in as {{ user.attributes.email }}!</h1>
        </template>
      </Authenticator>
      <button @click="logout">Sign Out</button>
      <button @click="router.go()"> Go to Game</button>
    </div>

    <div v-else>
      <router-view />
    </div>
  </div>
</template>


<style
    lang="scss" scoped>
@import '@/assets/base.css';

@keyframes slideInFromTop {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

div {
  color: white;
}
.big-button {
  font-size: 1.5em;
  padding: 1em;
  margin: 1em;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.loadingNotification {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
  font-size: 2em; /* Adjust as needed */
  color: #0c5460; /* Bootstrap info color */
  background-color: #d1ecf1; /* Bootstrap info background color */
  border-color: #bee5eb; /* Bootstrap info border color */
  border-radius: .25rem; /* Bootstrap border radius */
  padding: .75rem 1.25rem; /* Bootstrap padding */
  margin-bottom: 1rem; /* Bootstrap margin */
}

#errorText {
  cursor: default;
  animation: slideInFromTop 1s ease;
  font-size: 2em; /* Adjust as needed */
  color: #856404; /* Bootstrap warning color */
  background-color: #fff3cd; /* Bootstrap warning background color */
  border-color: #ffeeba; /* Bootstrap warning border color */
  border-radius: .25rem; /* Bootstrap border radius */
  padding: .75rem 1.25rem; /* Bootstrap padding */
  margin-bottom: 1rem; /* Bootstrap margin */
}

/* End Trivia Night */
</style>
